import PageHeader from "../core/App/PageHeader";
import PagePanel from "../core/App/PagePanel";
import styled from 'styled-components';
import { Box, Heading, tombac } from 'tombac';
import ChangePasswordForm from "./ChangePasswordForm";
import UserNotificationsForm from "./UserNotificationsForm";
import UserSettingsForm from "./UserSettingsForm";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Layout = styled.div.withConfig({
  displayName: "SettingsPage__Layout"
})(["display:grid;gap:24px;grid-auto-columns:1fr;grid-auto-flow:column;margin:0 auto;max-width:calc(1280px + ", ");padding:0 ", ";width:100%;grid-template:'password settings' 'notifications .';@media (max-width:1000px){display:block;padding:0;", "{padding:", ";}.Settings__change-pass,.Settings__ChangePasswordForm,.Settings__user-settings,.Settings__UserSettingsForm{width:100%;}}"], tombac.space(6), tombac.space(3), PagePanel, tombac.space(3));
const SettingsPage = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(PageHeader, {
    transparent: true,
    "data-sentry-element": "PageHeader",
    "data-sentry-source-file": "SettingsPage.tsx",
    "data-sentry-element": "PageHeader",
    children: /*#__PURE__*/_jsx(Heading, {
      as: "h1",
      level: 3,
      $mb: "0sp",
      "data-sentry-element": "Heading",
      "data-sentry-source-file": "SettingsPage.tsx",
      "data-sentry-element": "Heading",
      children: "Settings"
    })
  }), /*#__PURE__*/_jsxs(Layout, {
    "data-sentry-element": "Layout",
    "data-sentry-source-file": "SettingsPage.tsx",
    "data-sentry-element": "Layout",
    children: [/*#__PURE__*/_jsx(PagePanel, {
      style: {
        gridArea: 'password'
      },
      $width: "100%",
      breakpoint: 1000,
      $p: "10sp",
      $mb: "0",
      "data-sentry-element": "PagePanel",
      "data-sentry-source-file": "SettingsPage.tsx",
      "data-sentry-element": "PagePanel",
      children: /*#__PURE__*/_jsxs(Box, {
        className: "Settings__change-pass",
        $m: "0 auto",
        $w: "max-content",
        "data-sentry-element": "Box",
        "data-sentry-source-file": "SettingsPage.tsx",
        "data-sentry-element": "Box",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h2",
          level: 3,
          $mb: "3sp",
          "data-sentry-element": "Heading",
          "data-sentry-source-file": "SettingsPage.tsx",
          "data-sentry-element": "Heading",
          children: "Change password"
        }), /*#__PURE__*/_jsx(ChangePasswordForm, {
          $width: "40sp",
          className: "Settings__ChangePasswordForm",
          "data-sentry-element": "ChangePasswordForm",
          "data-sentry-source-file": "SettingsPage.tsx",
          "data-sentry-element": "ChangePasswordForm"
        })]
      })
    }), /*#__PURE__*/_jsx(PagePanel, {
      style: {
        gridArea: 'settings'
      },
      $width: "100%",
      breakpoint: 1000,
      $p: "10sp",
      $mb: "0",
      "data-sentry-element": "PagePanel",
      "data-sentry-source-file": "SettingsPage.tsx",
      "data-sentry-element": "PagePanel",
      children: /*#__PURE__*/_jsxs(Box, {
        className: "Settings__user-settings",
        $m: "0 auto",
        $w: "max-content",
        "data-sentry-element": "Box",
        "data-sentry-source-file": "SettingsPage.tsx",
        "data-sentry-element": "Box",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h2",
          level: 3,
          $mb: "3sp",
          "data-sentry-element": "Heading",
          "data-sentry-source-file": "SettingsPage.tsx",
          "data-sentry-element": "Heading",
          children: "Settings"
        }), /*#__PURE__*/_jsx(UserSettingsForm, {
          $width: "40sp",
          className: "Settings__UserSettingsForm",
          "data-sentry-element": "UserSettingsForm",
          "data-sentry-source-file": "SettingsPage.tsx",
          "data-sentry-element": "UserSettingsForm"
        })]
      })
    }), /*#__PURE__*/_jsx(PagePanel, {
      style: {
        gridArea: 'notifications'
      },
      $width: "100%",
      breakpoint: 1000,
      $p: "10sp",
      $mt: "0",
      "data-sentry-element": "PagePanel",
      "data-sentry-source-file": "SettingsPage.tsx",
      "data-sentry-element": "PagePanel",
      children: /*#__PURE__*/_jsxs(Box, {
        className: "Settings__user-notifications",
        $m: "0sp auto",
        $w: "max-content",
        "data-sentry-element": "Box",
        "data-sentry-source-file": "SettingsPage.tsx",
        "data-sentry-element": "Box",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h2",
          level: 3,
          $mb: "3sp",
          "data-sentry-element": "Heading",
          "data-sentry-source-file": "SettingsPage.tsx",
          "data-sentry-element": "Heading",
          children: "E-mail notifications"
        }), /*#__PURE__*/_jsx(UserNotificationsForm, {
          "data-sentry-element": "UserNotificationsForm",
          "data-sentry-source-file": "SettingsPage.tsx",
          "data-sentry-element": "UserNotificationsForm"
        })]
      })
    })]
  })]
});
export default SettingsPage;